export default "__VITE_ASSET__BGVX_0O4__"